import { render } from "./Live.vue?vue&type=template&id=e6e249bc&scoped=true&bindings={}"
import script from "./Live.vue?vue&type=script&lang=ts"
export * from "./Live.vue?vue&type=script&lang=ts"

import "./Live.vue?vue&type=style&index=0&id=e6e249bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e6e249bc"

export default script